<template>
  <div class="card">
    <h2>轮播图管理</h2>
    <button class="btn-add" @click="openDialog()">添加轮播</button>
    <table class="nav-table" border="1" cellpadding="8" cellspacing="0">
      <thead>
        <tr>
          <th>ID</th>
          <th>轮播图片</th>
          <th>关联导航</th>
          <th>排序</th>
          <th>操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in tableData" :key="item.id">
          <td>{{item.id}}</td>
          <td>
            <img :src="baseUrl + item.img" style="width:120px"/>
          </td>
          <td>{{ getNavName(item.nav_id) }}</td>
          <td>{{item.sort}}</td>
          <td>
            <button class="btn-edit" @click="editItem(item)">编辑</button>
            <button class="btn-del" @click="delItem(item.id)">删除</button>
          </td>
        </tr>
      </tbody>
    </table>
    <!--弹窗 样式和导航管理保持一致 -->
    <div v-if="dialogShow" class="dialog-mask" @click.self="dialogShow=false">
      <div class="dialog-box">
        <h3>{{isEdit?'编辑轮播':'新增轮播'}}</h3>
        <div class="form-row">
          <label>关联导航</label>
          <select v-model="form.nav_id">
            <option value="0">请选择导航</option>
            <option v-for="nav in navOptions" :key="nav.id" :value="nav.id">
              {{ nav.name }}
            </option>
          </select>
        </div>
        <div class="form-row">
          <label>轮播图片</label>
          <input ref="fileInput" type="file" accept="image/*" @change="onFileChange"/>
          <img v-if="form.img" :src="baseUrl+form.img" style="width:160px;margin-top:8px"/>
        </div>
        <div class="form-row">
          <label>排序(数字越大越靠前)</label>
          <input v-model="form.sort" type="number"/>
        </div>
        <div class="btn-group-footer">
          <button class="btn-cancel" @click="dialogShow=false">取消</button>
          <button class="btn-save" @click="submitForm">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name:"CarouselManage",
  data(){
    return{
      baseUrl:"https://asdf.hbbtfbf.cn",
      tableData:[],
      dialogShow:false,
      isEdit:false,
      form:{
        id:"",
        nav_id:0,
        img:"",
        sort:0
      },
      navOptions: [], //导航下拉选项列表
    }
  },
  mounted(){
    this.getList()
    this.getNavList() //加载导航下拉选项
  },
  methods:{
    // 获取导航列表，用于下拉选择【和你其他页面写法完全统一】
    async getNavList(){
      const res = await this.$request.post("action.php", "act=getNavList", {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      if (res.code === 200) {
        this.navOptions = res.data;
      }
    },
    // 根据nav_id获取导航名称，表格展示用
    getNavName(id){
      const findNav = this.navOptions.find(item=>item.id == id)
      return findNav ? findNav.name : '未选择'
    },
    // 获取轮播列表
    async getList(){
      const res = await this.$request.post("action.php", "act=carouselList", {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      if (res.code === 200) {
        this.tableData = res.data;
      }
    },
    openDialog(){
      this.isEdit=false
      this.form={id:"",nav_id:0,img:"",sort:0}
      this.dialogShow=true
    },
    editItem(item){
      this.isEdit=true
      this.form={...item}
      this.dialogShow=true
    },
    // 图片上传，拿到图片地址赋值给form.img
    onFileChange(e){
      const file = e.target.files[0];
      if(!file) return;
      const fd = new FormData();
      fd.append('file',file);
      this.$request.post('action.php?act=upload',fd).then(res=>{
        if(res.code===200){
          // 重点：把上传返回的图片路径赋值给form.img，保存的时候一起提交
          this.form.img = res.data.imgUrl;
        }else{
          alert(res.msg)
        }
      }).catch(err=>{
        console.error(err)
      })
    },
    // 提交新增/编辑轮播
    async submitForm(){
      // 校验
      if(!this.form.nav_id){
        alert("请选择关联导航");
        return;
      }
      if(!this.form.img){
        alert("请选择轮播图片");
        return;
      }
      let act = this.isEdit ? "carouselEdit" : "carouselAdd"
      let params = `act=${act}&nav_id=${this.form.nav_id}&sort=${this.form.sort}&img=${this.form.img}`
      // 如果是编辑，带上id
      if(this.isEdit){
        params += `&id=${this.form.id}`
      }
      const res = await this.$request.post("action.php", params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      });
      if(res.code===200){
        alert(res.msg || '保存成功')
        this.dialogShow=false
        this.getList()
        // 清空文件选择框
        this.$refs.fileInput.value = ''
      }
    },
    // 删除轮播
    async delItem(id){
      if(confirm("确定删除？")){
        const params = `act=carouselDel&id=${id}`
        const res = await this.$request.post("action.php", params, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        });
        if(res.code===200) {
          alert('删除成功')
          this.getList()
        }
      }
    }
  }
}
</script>
<style scoped>
.card{
  padding:20px;
}
.btn-add{
  background: #4080ff;
  color:#fff;
  border:none;
  padding:8px 16px;
  border-radius:4px;
  cursor:pointer;
  margin-bottom:15px;
}
.nav-table{
  width:100%;
  border-collapse: collapse;
  background:#fff;
}
.nav-table th{
  background:#f0f2f5;
  padding:10px;
}
.nav-table td{
  padding:10px;
}
.btn-edit{
  background:#4080ff;
  color:#fff;
  border:none;
  padding:4px 8px;
  border-radius:3px;
  cursor:pointer;
  margin:0 2px;
}
.btn-del{
  background:#f53f3f;
  color:#fff;
  border:none;
  padding:4px 8px;
  border-radius:3px;
  cursor:pointer;
  margin:0 2px;
}
.dialog-mask{
  position:fixed;
  top:0;
  left:0;
  right:0;
  bottom:0;
  background:rgba(0,0,0,0.5);
  display:flex;
  align-items:center;
  justify-content:center
}
.dialog-box{
  background:#fff;
  padding:24px;
  border-radius:8px;
  width:420px;
}
.form-row{
  margin:14px 0;
  display:flex;
  flex-direction:column;
  gap:6px
}
.form-row label{
  font-weight:500;
}
.form-row input, .form-row select{
  padding:8px;
  border:1px solid #dcdcdc;
  border-radius:4px;
}
.btn-group-footer{
  display:flex;
  justify-content:flex-end;
  gap:10px;
  margin-top:20px;
}
.btn-cancel{
  border:1px solid #dcdcdc;
  background:#fff;
  padding:8px 16px;
  border-radius:4px;
  cursor:pointer;
}
.btn-save{
  background:#4080ff;
  color:#fff;
  border:none;
  padding:8px 16px;
  border-radius:4px;
  cursor:pointer;
}
</style>
